<template>
  <div class="wrapper">
    <div class="pensure-spinner" :style="style" />
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core';

export default defineComponent({
  name: 'LoadingSpinner',
  props: {
    // @Prop({ type: String, default: '#606060' })
    color: {
      type: String,
      default: '#606060',
    },
    // @Prop({ type: Number, default: 75 })
    size: {
      type: Number,
      default: 75,
    },
    labelButtonColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style(): string {
      const styles = [
        !this.labelButtonColor ? `border-top: ${2 + this.size / 30}px solid ${this.color}` : '',
        `border-right: ${2 + this.size / 30}px solid transparent;`,
        `width: ${this.size}px`,
        `height: ${this.size}px`,
      ];
      return styles.join('; ');
    },
  },
});
</script>

<style scoped>
.wrapper {
  display: flex;
}

.pensure-spinner {
  width: 75px;
  height: 75px;
  background: transparent;
  border-top: 4px solid #606060;
  border-top-color: var(--button-label-color);
  border-right: 4px solid transparent;
  border-radius: 50%;
  -webkit-animation: 0.555s spin linear infinite;
  animation: 0.555s spin linear infinite;
}

@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
